export default __webpack_public_path__ + "static/media/align-left.2866e165.svg";